<footer *ngIf="catalog" (click)="toggleFooterBubble()">
  <span>&copy; <b>2reserve</b>.ch</span><span class="suffix"> &ndash; {{ 'FOOTER' | translate }}</span>
  <a
    *ngIf="showConditions && settings?.ShowConditions"
    [routerLink]="['/', catalog.name, currentLang(), 'terms-and-conditions']"
    (click)="$event.stopPropagation()"
  >
    | {{ customLabels.checkout().TermsAndConditions || 'TERMS_AND_CONDITIONS' | translate }}</a
  >
  <span> | {{ 'IMPRINT.IMPRINT' | translate }}</span>
</footer>
<div *ngIf="showFooterBubble()" class="cdk-overlay-container">
  <div class="cdk-overlay-backdrop" (click)="toggleFooterBubble()"></div>
  <div class="cdk-global-overlay-wrapper">
    <div class="cdk-overlay-pane">
      <div class="content-bubble bottom">
        <div class="content">
          <div class="address">
            <h3>{{ 'IMPRINT.CONTENT' | translate }}</h3>
            {{ catalog!.client.organization }}<br />
            <div *ngIf="catalog!.client.address">{{ catalog!.client.address }}</div>
            <div>{{ catalog!.client.zipcode }} {{ catalog!.client.location }}</div>
            <div *ngIf="catalog!.client.website">
              <a href="{{ catalog!.client.website | toHref }}" target="_blank">{{ catalog!.client.website }}</a>
            </div>
            <div *ngIf="catalog!.client.mail">
              <a href="mailto:{{ catalog!.client.mail }}">{{ catalog!.client.mail }}</a>
            </div>
            <div *ngIf="catalog!.client.phone">
              <a href="tel:{{ catalog!.client.phone }}">{{ catalog!.client.phone }}</a>
            </div>
          </div>
          <div class="address">
            <h3>{{ 'IMPRINT.SYSTEM' | translate }}</h3>
            2sic internet solutions GmbH<br />
            Langäulistrasse 62<br />
            9470 Buchs SG<br />
            <a href="https://www.2reserve.ch" target="_blank" class="logo">
              <img src="assets/logo.svg" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
